






















import { UiButton, UiMenu } from '../keen-ui';

import { FilterIdEnum } from '../../enums';

export default {
  name: 'realtime-filter-selector',
  components: {
    UiButton,
    UiMenu
  },
  computed: {
    selectedOptionText: function (): string {
      return (this.selectedOption.id > 60) ? this.$epb.utils.compileMessage(this.messages.hours.short, {
        hours: Math.floor(this.selectedOption.id / 60)
      }) : this.$epb.utils.compileMessage(this.messages.minutes.short, {
        minutes: this.selectedOption.id
      });
    },
    options: function () {
      return this.filter.config.intervalsInMinutes
        .filter((intervalInMinutes: number) =>
          (!this.filter.config.maxPeriodInMinutes || (intervalInMinutes <= this.filter.config.maxPeriodInMinutes)))
        .map((intervalInMinutes: number) => {
          let optionLabel: string;
          if (intervalInMinutes > 60) {
            optionLabel = this.$epb.utils.compileMessage(this.messages.hours.long, { hours: Math.floor(intervalInMinutes / 60) });
          } else {
            optionLabel = this.$epb.utils.compileMessage(this.messages.minutes.long, {
              minutes: intervalInMinutes
            });
          }
          return {
            id: intervalInMinutes,
            label: optionLabel
          };
        });
    },
    selectedOption: function () {
      return (this.options.find((option: any) => (option.id === this.filter.selectedValues)) || {});
    }
  },
  data: function () {
    return {
      messages: this.$epb.messages.filters.values[FilterIdEnum.REALTIME],
      FilterIdEnum
    };
  },
  props: {
    filter: Object
  },
  methods: {
    onSelectedOptionChange: function (selectedOption: any) {
      this.$emit('selectedValuesChange', selectedOption.id);
    }
  }
};

